import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  ErrorNotification,
  SuccessNotification,
  WarningNotification,
} from 'src/components/Notifications';
import { notificationsManager } from 'src/state/Notifications';
import * as fromRoot from 'src/state/rootReducer';
import i18next from 'i18next';
import DOMPurify from 'dompurify';

interface INotificationsComponent extends WithTranslation {
  notifications: ReturnType<typeof fromRoot.getNotificationsTypes>;
  remove: typeof notificationsManager.removeNotification;
}

const notificationComponents = {
  Error: ErrorNotification,
  Success: SuccessNotification,
  Warning: WarningNotification,
} as const;

const Notifications = ({ notifications, remove }: INotificationsComponent) => {
  const handleClose = (text: string) => () => remove(text);

  if (!notifications.length) {
    return null;
  }

  return (
    <div>
      {notifications.map(({ type, text, header }) => {
        const Component =
          notificationComponents[type as keyof typeof notificationComponents];
        if (!Component) return null;

        return (
          <Component
            key={text}
            header={
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(i18next.t(header)),
                }}
              />
            }
            text={
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(i18next.t(text)),
                }}
              />
            }
            onClose={handleClose(text)}
          />
        );
      })}
    </div>
  );
};

const connectedComponent = connect(
  state => ({
    notifications: fromRoot.getNotificationsTypes(state),
  }),
  {
    remove: notificationsManager.removeNotification,
  }
)(Notifications);

export default withTranslation()(connectedComponent);
